import { Injectable } from "@angular/core";

@Injectable()
export class Global {
    static readonly priorities = {
        1: {
            label: 'Priorität 1',
            tooltip: 'Priorität 1',
            hint: 'Hohe Priorität',
            color: "p1"
        },
        2: {
            label: 'Priorität 2',
            tooltip: 'Priorität 2',
            hint: undefined,
            color: "p2"
        },
        3: {
            label: 'Priorität 3',
            tooltip: 'Priorität 3',
            hint: undefined,
            color: "p3"
        },
        4: {
            label: 'Priorität 4',
            tooltip: 'Priorität 4',
            hint: undefined,
            color: "p4"
        },
        5: {
            label: 'Priorität 5',
            tooltip: 'Priorität 5',
            hint: undefined,
            color: "p5"
        },
        6: {
            label: 'Priorität 6',
            tooltip: 'Priorität 6',
            hint: 'Geringe Priorität',
            color: "p6"
        }
    } as const;

    static readonly priorityOptions = Object.entries(Global.priorities).map(([value, { label, hint }]) => ({ value: Number(value), label, hint }));
}